export default __webpack_public_path__ + "static/media/emoji.80d608e9.svg";